import type { CompanyOnboardingRequest } from '@/widgets/auth/CompanyOnboarding/models';

import { baseClient } from '@/shared/api/baseClient';

export const companyOnboardingAsync = async (
  body: Omit<CompanyOnboardingRequest, 'invitations'>
) => {
  if (import.meta.env.MODE === 'dev') {
    return Promise.reject(new Error('Disabled on prod'));
  }
  const response = await baseClient.post<CompanyOnboardingRequest>(
    '/organizations',
    body
  );
  return response.data;
};
